/**
 * Texte zu den Rückmeldungen der Microsoft-Callbacks (BIC-Backend#213). Das Backend leitet nach der
 * Zustimmung bzw. dem Login mit `consent`/`reason` bzw. `siteSession` in die Organisationseinstellungen.
 */
export const CONSENT_ERROR_TEXTS: Record<string, string> = {
  access_denied: 'Die Zustimmung wurde in Microsoft abgelehnt.',
  expired: 'Der Zustimmungslink war abgelaufen. Bitte einen neuen anfordern.',
  not_consented: 'Microsoft hat keine Zustimmung gemeldet.',
  already_processed: 'Dieser Zustimmungslink wurde bereits verwendet.',
};

export const STATE_ERROR_TEXTS: Record<string, string> = {
  missing_state: 'Die Rückmeldung von Microsoft war unvollständig.',
  unknown_state: 'Die Rückmeldung von Microsoft ließ sich keiner Anfrage zuordnen. Bitte erneut versuchen.',
};

export function consentErrorText(reason: string | null): string {
  return (reason && CONSENT_ERROR_TEXTS[reason]) || 'Die Verbindung mit SharePoint ist fehlgeschlagen.';
}
